import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
@Component({
  selector: 'app-box-dashboard',
  templateUrl: './box-dashboard.component.html',
  styleUrls: ['./box-dashboard.component.css']
})
export class BoxDashboardComponent implements OnInit {

  
    @Input() title: string;
    @Input() route: string;
    @Input() image: string;
  
    constructor(private router: Router) {
    }
  
    ngOnInit() { }
  
    go() {
      return this.router.navigateByUrl( `/${this.route}`);
    }
  
  }
  